import "../../Default.css"
import "./Weather.css"
import { WeatherType } from "./weatherType";
import settingsData from "./weather.json"
import { Link, Route, Routes } from "react-router-dom";
import WeatherCity from "./WeatherCity";
const settings: WeatherType = settingsData as any;


function WeatherMenu() {
    return(
        <>
            <div className="page-title">
                Prognoza pogody
            </div>
            <div className="navigation-wraper">
                <nav className='small-nav-bar navigation-bar'>
                    {settings.cities.map((city, index) => 
                    <div className='weather-menu-item' key={index}>
                        <Link to={`./${city.route}`}>
                            <p>{city.name}</p>
                        </Link>
                    </div>                   
                    )}
                </nav>
            </div>
        </>
    )
}


function Weather() {
    return (
        <>
            <Routes>
              <Route path='/' element={WeatherMenu()}></Route>
              {settings.cities.map((city,index) => 
                <Route path={`/${city.route}/*`} key={index.toString()} element={<WeatherCity city={city}/>}/>
              )}
            </Routes>
        </>
      );
}

export default Weather;